import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { PartNumber } from '@app/shared/models/partNumber.model';
import { LineService } from '@app/core/services/line.service';
import { Log } from 'ng2-logger';
import { Line } from '@app/shared/models/line.model';

@Component({
  selector: 'app-part-number-lines-form',
  templateUrl: './part-number-lines-form.component.html',
  styleUrls: ['./part-number-lines-form.component.scss']
})
export class PartNumberLinesFormComponent implements OnInit {
  _logger = Log.create(PartNumberLinesFormComponent.name);

  @Input() lines: Line[] = [];
  @Input() showValidations;
  @Input() mode;

  get isFormValid() {
    return this.linesForm.valid;
  }

  public isSPI: boolean;

  public linesForm: UntypedFormGroup
  public partNumber: PartNumber;

  isLoading: boolean;

  constructor() { }

  ngOnInit() {
    this._logger.info("ngOnInit:: Preparing part number lines form");
    this.linesForm = new UntypedFormGroup({
      'lines': new UntypedFormControl([])
    })
  }

  public init(partNumber: PartNumber) {
    if (partNumber) {
      this.partNumber = partNumber;
      this.partNumber.lines.forEach(x => x.isSPI && !x.name.includes('SPI - ') ? x.name = 'SPI - '.concat(x.name) : null);
      this.loadFormValue();
    }
  }

  public getFormDetails() {
    this._logger.info("getFormEquipments::", this.partNumber);
    const formData = this.linesForm.getRawValue();
    return {...formData};
  }

  public resetForm() {
    this._logger.info("resetForm:: Resetting part number details form", this.partNumber);
    this.linesForm.reset();
  }

  public isReadOnly() {
      return this.mode === 'view';
  }

  private loadFormValue() {
    if (!this.partNumber) {
      return;
    }

    const { lines } = this.partNumber;

    this.linesForm.setValue({ lines });
  }
}
